 /* custom-cscience-carousel.js
   Minimal, safe, defensive JS to render the carousel placeholder and expose API.
   Replace the asset content with this exact file to eliminate the "<" error.
*/

(function (window, document) {
  'use strict';

  // Defensive: don't run if DOM isn't ready yet
  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  // Minimal no-op default dataset (5 items)
  var DEFAULT_IMAGE = 'https://cdn.shopify.com/s/files/1/0947/3769/5039/files/product_photo_copy.webp?v=1763136865';
  var DEFAULT_DATA = [
    { href:'#', bigText:'93%', subtitle:'saw less shedding*', footnote:'', image: DEFAULT_IMAGE, imageAlt:'1', shopText:'Shop →' },
    { href:'#', bigText:'Up to 91%', subtitle:'reduction in hair shedding*', footnote:'', image: DEFAULT_IMAGE, imageAlt:'2', shopText:'Shop →' },
    { href:'#', bigText:'96%', subtitle:'less new gray hairs*', footnote:'', image: DEFAULT_IMAGE, imageAlt:'3', shopText:'Shop →' },
    { href:'#', bigText:'72 hours', subtitle:'hydration & frizz reduction*', footnote:'', image: DEFAULT_IMAGE, imageAlt:'4', shopText:'Shop →' },
    { href:'#', bigText:'2x', subtitle:'the volume*', footnote:'', image: DEFAULT_IMAGE, imageAlt:'5', shopText:'Shop →' }
  ];

  /* Create card element */
  function createCard(item) {
    var a = document.createElement('a');
    a.className = 'csc-card';
    a.href = item.href || '#';
    a.setAttribute('role', 'link');

    var top = document.createElement('div'); top.className = 'csc-card-top';
    var stat = document.createElement('div'); stat.className = 'csc-stat'; stat.textContent = item.bigText || '';
    var sub = document.createElement('div'); sub.className = 'csc-subtitle'; sub.textContent = item.subtitle || '';
    var foot = document.createElement('div'); foot.className = 'csc-footnote'; foot.textContent = item.footnote || '';
    var shop = document.createElement('div'); shop.className = 'csc-shop'; shop.textContent = item.shopText || 'Shop →';
    shop.setAttribute('aria-hidden', 'true');

    top.appendChild(stat); top.appendChild(sub); top.appendChild(foot); top.appendChild(shop);

    var imgWrap = document.createElement('div'); imgWrap.className = 'csc-card-image';
    var img = document.createElement('img');
    img.src = item.image || DEFAULT_IMAGE;
    img.alt = item.imageAlt || item.bigText || 'product';
    img.loading = 'lazy';
    imgWrap.appendChild(img);

    a.appendChild(top);
    a.appendChild(imgWrap);

    return a;
  }

  function render(targetSelector, data) {
    var target = document.querySelector(targetSelector);
    if (!target) {
      console.warn('cscienceCarousel: target not found', targetSelector);
      return null;
    }

    // Ensure .csc-inner exists, otherwise create a safe structure
    var wrapper = target.closest('.csc-carousel');
    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'csc-carousel csc-carousel--force';
      var inner = document.createElement('div'); inner.className = 'csc-inner';
      // replace target with wrapper->inner->target
      target.parentNode.replaceChild(wrapper, target);
      inner.appendChild(target);
      wrapper.appendChild(inner);
    }

    var renderContainer = wrapper.querySelector('.csc-inner') || wrapper;

    // remove old grid if present
    var old = renderContainer.querySelector('.csc-grid');
    if (old) old.remove();

    var grid = document.createElement('div');
    grid.className = 'csc-grid';

    var items = Array.isArray(data) && data.length ? data.slice(0,5) : DEFAULT_DATA;
    while (items.length < 5) items.push(DEFAULT_DATA[items.length]);

    items.forEach(function(it) {
      grid.appendChild(createCard(it));
    });

    renderContainer.appendChild(grid);
   wrapper.__cscience_data = items;

    // add pagination dots using custom-progress styles
    addDots(wrapper, grid, items.length);

    return wrapper;
  }



    // Add custom-progress style pagination dots below this carousel
  function addDots(wrapper, scrollContainer, count) {
    if (!wrapper || !scrollContainer || count <= 1) return;

    // remove old pagination if it exists
    var old = wrapper.querySelector('.custom-progress-pagination');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var pagination = document.createElement('div');
    pagination.className = 'custom-progress-pagination';

    var buttons = [];
    var currentIndex = 0;

    function setActive(idx) {
      currentIndex = idx;
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-selected', i === idx ? 'true' : 'false');
      }
    }

    function goTo(idx) {
      if (idx < 0 || idx >= count) return;

      var totalWidth = scrollContainer.scrollWidth;
      var slideWidth = totalWidth / count;
      var targetLeft = idx * slideWidth;

      scrollContainer.scrollTo({
        left: targetLeft,
        behavior: 'smooth'
      });

      setActive(idx);
    }

    function updateActiveFromScroll() {
      var totalWidth = scrollContainer.scrollWidth;
      if (!totalWidth) return;

      var slideWidth = totalWidth / count;
      var idx = Math.round(scrollContainer.scrollLeft / slideWidth);

      if (idx < 0) idx = 0;
      if (idx >= count) idx = count - 1;

      if (idx !== currentIndex) {
        setActive(idx);
      }
    }

    for (var i = 0; i < count; i++) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

      (function (i) {
        btn.addEventListener('click', function () {
          goTo(i);
        });
      })(i);

      buttons.push(btn);
      pagination.appendChild(btn);
    }

    // place dots right under the inner wrapper
    var inner = wrapper.querySelector('.csc-inner') || wrapper;
    inner.parentNode.insertBefore(pagination, inner.nextSibling);

    // update active dot when user scrolls/swipes (mobile)
    scrollContainer.addEventListener('scroll', updateActiveFromScroll);

    // initial state
    setActive(0);
  }










  var API = {
    init: function(targetSelector, data, options) {
      try { return render(targetSelector || '.csc-carousel-target', data || DEFAULT_DATA); }
      catch (e) { console.error('cscienceCarousel.init error', e); }
    },
    updateCard: function(index, newData) {
      try {
        var wrapper = document.querySelector('.csc-carousel');
        if (!wrapper) return;
        var grid = wrapper.querySelector('.csc-grid');
        if (!grid) return;
        var cards = grid.querySelectorAll('.csc-card');
        if (index < 0 || index >= cards.length) return;
        grid.replaceChild(createCard(newData), cards[index]);
      } catch (e) { console.error('cscienceCarousel.updateCard error', e); }
    }
  };

  ready(function () {
    // Auto-init safely if placeholder exists
    var placeholder = document.querySelector('.csc-carousel-target');
    if (placeholder) {
      API.init('.csc-carousel-target', DEFAULT_DATA);
    }
    // Expose API
    window.cscienceCarousel = API;
  });

})(window, document);
 



